import React from 'react';
import { FD140, FD143 } from '../../../services/d204Api';

interface Tab5Props {
  formData: Partial<FD140>;
  attachments: Partial<FD143>[];
  isEditing: boolean;
}

const Tab5Attachment: React.FC<Tab5Props> = React.memo(({
  formData, attachments, isEditing,
}) => {
  return (
    <div className="form-section odd">
      <span className="section-tag">附屬明細</span>

      {/* FD143 grid */}
      <div className="table-wrapper" style={{ marginBottom: 16 }}>
        <div className="table-scroll">
          <table className="data-table">
            <thead>
              <tr>
                <th style={{ width: 40 }} data-contract-field="fd143_02">項數</th>
                <th data-contract-field="fd143_11">異常說明代號</th>
                <th data-contract-field="fd143_12">異常說明</th>
                <th data-contract-field="fd143_13">預計作業日期</th>
                <th data-contract-field="fd143_14">單據號碼</th>
              </tr>
            </thead>
            <tbody>
              {attachments.length === 0 ? (
                <tr><td colSpan={5} style={{ textAlign: 'center', color: '#999' }}>尚無附屬明細</td></tr>
              ) : (
                attachments.map((row, i) => (
                  <tr key={i}>
                    <td>{row.fd143_02 || i + 1}</td>
                    <td>{row.fd143_11 || ''}</td>
                    <td>{row.fd143_12 || ''}</td>
                    <td>{row.fd143_13 || ''}</td>
                    <td>{row.fd143_14 || ''}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* fd140_61 editbox (read-only) */}
      <div style={{ marginTop: 12 }}>
        <label style={{ fontSize: 13, marginBottom: 4, display: 'block' }}>備註</label>
        <textarea readOnly style={{ width: '100%', minHeight: 100 }}
          value={formData.fd140_61 || ''} data-contract-field="fd140_61"
        />
      </div>
    </div>
  );
});

Tab5Attachment.displayName = 'Tab5Attachment';
export default Tab5Attachment;
